import { render, staticRenderFns } from "./mobile-number-updated.html?vue&type=template&id=1319e3ee&external"
import script from "./mobile-number-updated.js?vue&type=script&lang=js&external"
export * from "./mobile-number-updated.js?vue&type=script&lang=js&external"
import style0 from "./mobile-number-updated.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports